import * as React from "react"
import "./divider.scss"

const Divider: React.FC<{ className?: string }> = ({ className = "" }) => {
	return <div className={`divider ${className}`} />
}

export default Divider
